import _ from 'lodash';
import {UserAction} from '~/redux/actions/UserActions';

export interface UserState {
    authToken?: string;
}

export interface UserHintsAttributes {
    brandIds?: number[];
    orgIds?: number[];
    storeIds?: number[];
}

const DEFAULT_USER_STATE = {
    authToken: undefined,
    hints: {
        brandIds: undefined,
        orgIds: undefined,
        storeIds: undefined,
    },
};

const {LOG_IN, LOG_OUT, RECEIVE_USER_HINTS} = UserAction;

const UserReducer = (state = DEFAULT_USER_STATE, action) => {
    const {type: typeOfAction, value} = action;

    switch (typeOfAction) {
        case LOG_OUT:
            return DEFAULT_USER_STATE;
        case LOG_IN:
            return {
                ...state,
                authToken: value,
            };
        case RECEIVE_USER_HINTS:
            return {
                ...state,
                hints: value,
            };
        default:
            return state;
    }
};

export default UserReducer;
